import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { MetaData } from "../Courses/GetAllRequests";
import { Question } from "../Quiz/GetQuizById";
type BankQuestionsDTO =  {
    meta:MetaData;
    questions:Question[];
}
export type Quiz = {
    id: string;
    title: string;
    lectureId: string;
    openLectureId?: string;
    chapterId:string
}
type getBankResponse = {
    statusCode?: number;
    error?: null | ApiError;
    data?: BankQuestionsDTO;
  
}
export interface GetBankQuestionsParams {
    page?: number;
    limit: number;
    lectureId?: string;
    chapterId?: string;
    courseId?: string;
}

export const GetAllBankQuestions = async (params: GetBankQuestionsParams): Promise<getBankResponse> => {
    try {
        const response = await axios.get(`/questions-bank/all`, {
            params: {
                page: params.page,
                limit: params.limit,
                lectureId: params.lectureId,
                chapterId: params.chapterId,
                courseId: params.courseId,
            },

        });
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};